<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_001
 * @created at      :   2026/02/02
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST001 from '@/views/popupSearch/PopupMST001/store';
import helpers from '@/utils/helpers';

var PopupMST001Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST001')) {
            store.registerModule('PopupMST001', PopupMST001);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST001', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST001', ['searchMst001Info']),
        ...mapMutations('PopupMST001', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
            } else if (this.initData !== undefined && this.initData !== null) {
                this.data.company_cd = this.initData;
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchMst001Info(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchMst001Info(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.customer_cd);
            this.$emit('onReferValueName', item.customer_name);
            this.$emit('close');
        }
    }
};
export default PopupMST001Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
